import Accordion from "@/components/common/Accordion";
import GoogleMap from "./GoogleMap";
import { pxChangeVw } from "@/utils";
import useTranslate from "@/hooks/useTranslate";
import classNames from "classnames";
import { calcByUiRatio } from "@/constants/runtime.config";
import { homeAtom } from "@/atoms/home";
import { alertDetailAtom, cityAtom } from "@/atoms/alertDetail";
const AlertDetail: React.FC = () => {
  const city = useAtomValue(cityAtom);
  const [alertDetail, setAlertDetail] = useAtom(alertDetailAtom);
  const [expandIndex, setExpandIndex] = useState(0);
  const { state } = useLocation();
  const { pathname } = useLocation();
  const fetchAlertDetailData = useSetAtom(homeAtom);
  useEffect(() => {
    fetchAlertDetailData(pathname);
  }, []);
  useEffect(() => {
    const expandId = state?.expandId;
    if (expandId && alertDetail?.length) {
      const _expandIndex = alertDetail.findIndex((item: any) => item.AlertID === expandId);
      if (_expandIndex >= 0) {
        setExpandIndex(() => _expandIndex);
      }
    }
  }, [alertDetail]);
  const { $t } = useTranslate();
  const renderTitle = ({ item, index: _index, handleClick }: any) => {
    const byRatio = calcByUiRatio();
    return (
      <>
        <div
          className={classNames(["flex justify-between items-center text-12"])}
          onClick={() => handleClick(item, _index)}
        >
          <div className="w-full border-b-1 border-b-solid border-b-[var(--app-border-05)] pb-15 flex flex-col gap-y-4">
            <div className="flex justify-between items-center gap-x-4">
              <div className="flex items-center gap-x-8">
                <AlertSvg
                  size={"20px"}
                  color={`rgba(${item?.Color?.Red}, ${item?.Color?.Green}, ${item?.Color?.Blue}, 0.3)`}
                />
                <div
                  className="color-[var(--data-color)]"
                  style={{
                    // @ts-ignore
                    "--data-color": `var(--app-bg-01)`,
                  }}
                >
                  {item?.Description?.Localized}
                </div>
              </div>
              <SvgIcon size={20 * byRatio} name={item?.isExpand ? "svg05" : "svg01"} />
            </div>
            <div className={classNames(["flex items-center gap-x-16 text-12"])}>
              <div>{$t("title16")}</div> <div>{item?.Source}</div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const renderContent = ({ item, index }: any) => {
    return (
      <div className={classNames(["flex flex-col gap-y-8 text-12"])}>
        <div className="flex flex-col gap-y-8">
          <p className={index === 0 ? "flex justify-between items-center" : ""} style={{ opacity: 0.8 }}>
            <i>{$t("title17")}</i>
            <i>{$t("title18")}</i>
          </p>
          <p
            className={index === 0 ? "flex justify-between items-center" : ""}
            style={{ fontSize: pxChangeVw("16px") }}
          >
            <i>{item?.detail?.start}</i>
            <i>{item?.detail?.end}</i>
          </p>
          <p className={index === 0 ? "flex justify-between items-center" : ""}>
            <i>{item?.detail?.start_week}</i>
            <i>{item?.detail?.end_week}</i>
          </p>
          <div style={{ width: "100%", height: pxChangeVw("180px") }}>{city.geo && <GoogleMap {...city.geo} />}</div>
          <p
            className={index === 0 ? "flex justify-between items-center" : ""}
            style={{
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            {item?.detail?.Summary}
          </p>
        </div>
      </div>
    );
  };
  return (
    <div className={classNames(["flex flex-col justify-start gap-y-10 box-border p-[0_16px]"])}>
      {!!alertDetail?.length && (
        <Accordion
          accordionList={alertDetail}
          setLocalList={setAlertDetail}
          renderTitle={renderTitle}
          renderContent={renderContent}
          expandIndex={expandIndex}
        />
      )}
    </div>
  );
};
export default AlertDetail;
